import React, { useMemo } from 'react';
import classnames from 'classnames';
import logoThomasSigne from './ThomasSigneSIGN.png';
import logoThomasSigneTopbar from './ThomasSigneSIGNneg.png';
import logoSigneblockTopbar from './logoSBSignenegativoNoBorder.png';
import logoSigneblockLogin from './logoSBSignpositivo.png';
import logoUruk from './urukcolor.png';

const urls = process.env.REACT_APP_URUK_FRONT_URL.split(',');

const logoConfig = {
  [urls[0]]: logoUruk,
  [urls[1]]: logoSigneblockLogin,
  [urls[1] + '_topbar']: logoSigneblockTopbar,
  [urls[2] + '_topbar']: logoThomasSigneTopbar,
  [urls[2]]: logoThomasSigne
};

const RenderLogoByHostname = ({ topBar, classNameLogo, customLogo }) => {
  const currentHostname = 'http://' + window.location.hostname;
  const logoKey = topBar ? currentHostname + '_topbar' : currentHostname;

  const defalutLogo = useMemo(() => logoConfig[logoKey] || logoUruk, [logoKey]);

  const style = useMemo(() => {
    let baseStyle = { height: 'auto', width: '370px', marginBottom: '50px' };
    if (defalutLogo === logoUruk && !topBar) {
      baseStyle.width = '200px';
    }
    return baseStyle;
  }, [defalutLogo, topBar]);

  return (
    <img src={customLogo || defalutLogo} alt='Logo' style={!topBar ? style : undefined} className={classnames({ [classNameLogo]: topBar })} />
  );
};

export default RenderLogoByHostname;
